<template>
  <div class="lesson">
    <el-breadcrumb class="menu nav-bar-route-box" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="item in routeArr" :key="item.path">
        <a class="item">{{ item.title }}</a>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <section class="article">
      <p class="title">{{ newsDeatil.title }}</p>
      <p class="time">发布时间：{{newsDeatil.time}}</p>
      <div class="content" v-for="(item, index) in newsDeatil.detail" :key="index">
        <p class="para" v-if="item.type === 'p'">{{ item.val }}</p>
        <img v-if="item.type === 'img'" class="newsImg" :src="item.val" alt="" />
      </div>
      <p></p>
    </section>
  </div>
</template>

<script>
import { LESSONS_IDX3_DATA } from '../../utils/LingXunData'
export default {
  name: 'NewsDetail',
  data () {
    return {
      contentList: LESSONS_IDX3_DATA,
      routeArr: [],
      newsDeatil: {}
    }
  },
  filters: {
    textFilter (val) {
      return val.replace('ZM', '')
    }
  },
  created () {
    const matched = this.$route.matched
    this.newsDeatil = JSON.parse(localStorage.getItem('NEWS_DETAIL'))
    matched[0] && (matched[0].title = '最新资讯')
    matched[1] && (matched[1].title = this.newsDeatil.title)
    this.routeArr = matched

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }
}
</script>
<style scoped lang="scss">
  .lesson{
    height: auto;
    min-height: 768px;
    width: 1192px;
    margin: 0 auto;
    .menu{
      height: 80px;
      font-size: 14px;
      color: #666;
      text-align: left;
      line-height: 80px;
    }
    .article{
      width: calc(1192px - 48px);
      height: auto;
      padding: 24px 32px;
      background-color: #fff;
      overflow: hidden;
      .title{
        height: 30px;
        font-size: 24px;
        font-weight: 500;
        color: #333;
        text-align: center;
        line-height: 30px;
        margin: 32px 0 10px 0;
      }
      .time{
        height: 30px;
        font-size: 14px;
        color: #999;
        text-align: center;
        line-height: 30px;
        margin-bottom: 40px;

      }
      .content{
        height: auto;
        overflow: hidden;
        .para{
          font-size: 16px;
          color: #666;
          text-align: left;
          line-height: 30px;
        }
        .newsImg{
          width: 100%;
          height: auto;
        }
      }
    }
    .img{
      height: auto;
      width: 100%;
    }
    .mb32{
      margin-bottom: 32px;
    }
  }
</style>
